import { FunctionComponent as F, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link as ScrollLink } from 'react-scroll';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ProtoplanLogoText from '../images/logo_text_large.svg';
import Step1 from '../images/step 1 - empty protocol.png';
import Step2 from '../images/step 2 - choose a product.png';
import Step3 from '../images/step 3 - choose a listing.png';
import Step4 from '../images/step 4 - add your dose.png';
import Step5 from '../images/step 5 - total cost per month.png';
import Button from "../components/UI/Button/Button";
import { PROTOCOL } from "../core/router/paths";
import { getNListings } from "../core/http/listing";
import { getNProducts } from "../core/http/product";


const SplashScreen: F = () =>
{
  const navigate = useNavigate();

  const [nListings, setNListings] = useState(">5k");
  const [nProducts, setNProducts] = useState(">1k");

  useEffect(() =>
  {
    getNListings().then(data => setNListings(data.nListings));
  }, [nListings]);

  useEffect(() =>
  {
    getNProducts().then(data => setNProducts(data.nProducts));
  }, [nProducts]);

  return (
    <Container>
      <Stack sx={{ pt: 20 }} spacing={2} justifyContent='center' direction='column' alignItems='center'>
        <ProtoplanLogoText/>
        <Typography variant='body1'>The supplement budgeting tool.</Typography>
        <Box sx={{ height: 150, display: 'flex' }} alignItems='center' justifyContent='center'>
          <Button label='Get started 📝' onClick={() => navigate(PROTOCOL)}/>
        </Box>
        <ScrollLink to='whyProtoplan' spy={true} smooth={true}>
          <KeyboardArrowDownIcon
            sx={{ mt: 3, ml: 1, fontSize: 90, color: 'lightGray', cursor: 'pointer' }}/>
        </ScrollLink>
        <Box sx={{ height: 200 }}/>
      </Stack>
      <Box sx={{ pr: 10, pl: 10 }}>
        <Typography variant='body1' id='whyProtoplan'>
          {"Ever tried to calculate the true cost of your supplement protocol? Doses, volumes, \
          fluctuating product prices, multiple family members…. it quickly gets complicated. And \
          where was it you last bought that bottle of California Poppy?"}
        </Typography>
        <br/>
        <Box sx={{ display: 'flex' }} alignItems='center' justifyContent='center'>
          {"🤔"}
        </Box>
        <br/>
        <Typography variant='body1'>
          {"Now there is an easier way.  A budgeting tool, complete with a database of " + nProducts + " products\
         and " + nListings + " listings, with new entries added continuously. Simply choose the products you buy, \
         enter your dosing and receive a total monthly cost. Need to adjust your protocol? The price \
         will update automatically."}
        </Typography>
        <br/>
        <Box sx={{ display: 'flex' }} alignItems='center' justifyContent='center'>
          {"🤯"}
        </Box>
        <br/>
        <Box sx={{ height: 10 }}/>
        <Box sx={{ height: 80 }} id='howDoIUseIt'>
          <Typography variant='h5'>
            Great - how do I use it?
          </Typography>
        </Box>
        <Typography variant='body1'>
          {"See the guide below showing the basic features. This should be enough to get started!"}
        </Typography>
        <Box sx={{ height: 20 }}/>
        <Stack spacing={0.2} justifyContent='center' direction='column' alignItems='center'>
          <ScrollLink to='step1' spy={true} smooth={true}>
            <KeyboardArrowDownIcon
              sx={{ mt: 3, ml: 1, fontSize: 90, color: 'lightGray', cursor: 'pointer' }}/>
          </ScrollLink>
          <Box sx={{ height: 60 }}/>
          <img src={Step1} width='700px' id='step1'/>
          <ScrollLink to='step2' spy={true} smooth={true}>
            <KeyboardArrowDownIcon
              sx={{ mt: 3, ml: 1, fontSize: 90, color: 'lightGray', cursor: 'pointer' }}/>
          </ScrollLink>
          <Box sx={{ height: 60 }}/>
          <img src={Step2} width='700px' id='step2'/>
          <ScrollLink to='step3' spy={true} smooth={true}>
            <KeyboardArrowDownIcon
              sx={{ mt: 3, ml: 1, fontSize: 90, color: 'lightGray', cursor: 'pointer' }}/>
          </ScrollLink>
          <Box sx={{ height: 60 }}/>
          <img src={Step3} width='700px' id='step3'/>
          <ScrollLink to='step4' spy={true} smooth={true}>
            <KeyboardArrowDownIcon
              sx={{ mt: 3, ml: 1, fontSize: 90, color: 'lightGray', cursor: 'pointer' }}/>
          </ScrollLink>
          <Box sx={{ height: 60 }}/>
          <img src={Step4} width='700px' id='step4'/>
          <ScrollLink to='step5' spy={true} smooth={true}>
            <KeyboardArrowDownIcon
              sx={{ mt: 3, ml: 1, fontSize: 90, color: 'lightGray', cursor: 'pointer' }}/>
          </ScrollLink>
          <Box sx={{ height: 60 }}/>
          <img src={Step5} width='700px' id='step5'/>
          <Box sx={{ height: 200, display: 'flex' }} alignItems='center' justifyContent='center'>
            <Button label='Get started 📝' onClick={() => navigate(PROTOCOL)}/>
          </Box>
        </Stack>
      </Box>
    </Container>);
};

export default SplashScreen;
